<script setup>
import { useMapGetter } from 'dashboard/composables/store.js';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  to: { type: [Object, String], default: '' },
  label: { type: String, default: '' },
  icon: { type: [String, Object], default: '' },
  expandable: { type: Boolean, default: false },
  isExpanded: { type: Boolean, default: false },
  isActive: { type: Boolean, default: false },
  hasActiveChild: { type: Boolean, default: false },
  getterKeys: { type: Object, default: () => ({}) },
  showLabel: { type: Boolean, default: true },
});

const emit = defineEmits(['toggle']);

const showBadge = useMapGetter(props.getterKeys.badge);
</script>

<template>
  <slot />
  <component
    :is="to ? 'router-link' : 'div'"
    class="flex items-center gap-2 pl-7 py-1.5 h-10 text-n-slate-5 dark:text-n-slate-10 font-medium"
    role="button"
    :to="to"
    :title="label"
    :class="{
      'bg-n-brand-1': isActive || hasActiveChild,
      'hover:bg-n-alpha-2': !isActive && !hasActiveChild,
      'pl-7': !showLabel,
      'px-8': showLabel,
    }"
    @click.stop="emit('toggle')"
  >
    <div v-if="icon" class="relative flex items-center gap-2">
      <Icon v-if="icon" :icon="icon" class="size-4" />
      <span
        v-if="showBadge"
        class="size-2 -top-px ltr:-right-px rtl:-left-px bg-n-brand absolute rounded-full border border-n-solid-2"
      />
    </div>
    <span
      v-if="props.showLabel"
      class="text-sm font-medium leading-5 flex-grow"
    >
      {{ label }}
    </span>
    <span
      v-if="expandable"
      v-show="isExpanded && showLabel"
      class="i-lucide-chevron-up size-3"
      @click.stop="emit('toggle')"
    />
    <span
      v-if="expandable"
      v-show="!isExpanded && showLabel"
      class="i-lucide-chevron-down size-3"
      @click.stop="emit('toggle')"
    />
  </component>
</template>
